import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';

import DataFilter from '../../containers/Dashboard/DataFilter';
import {
    Cotainer
} from '../../components/AppWrapper';
import Coins from '../../components/Coins';
// import { createWalletAddress, getUserInfo } from '../../common/fetch';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'
import { DescriptionWrapper } from './style';

const TABLE_WALLET_COLUMN = (
    crypto_wallet = {},
    balanceData,
    // getCryptoAddress = () => { },
    openDeposit = () => { },
    openWithdraw = () => { },
) => [
        {
            title: 'Coin',
            dataIndex: 'symbol',
            key: 'symbol',
            render: (symbol, { fullname }) => (
                <div className="flex-col">
                    <Coins type={symbol.toLowerCase()} small={true} />{fullname}
                </div>
            )
        },
        {
            title: 'Generate',
            dataIndex: 'status',
            key: 'status',
            render: (key, { symbol, allow_deposit, allow_withdrawal, fullname, network }) => (
                <div>
                    {/* {crypto_wallet[symbol]
                        ?  */}
                        <div>
                        {allow_deposit ? <Link onClick={() => openDeposit(symbol, fullname, network)}>Deposit</Link> : <span>Deposit</span>}
                            {allow_withdrawal
                            ? <span>{' '}/{' '}<Link onClick={() => openWithdraw(symbol, fullname, network)}>Withdraw</Link></span>
                                : <span>{' '}/{' '}Withdraw</span>
                            }
                        </div>
                      {/* : <Link onClick={() => getCryptoAddress(symbol)}>Generate</Link>
                    } */}
                </div>
            )
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            render: (key, { symbol }) =>
                <div>
                    {balanceData[`${symbol}_balance`]}
                </div>
        },
    ];

const WalletBalance = ({
    coins = [],
    exchange = {},
    balance,
    crypto_wallet,
    // userAction,
    openDeposit,
    openWithdraw,
    constant
}) => {
    const [coinsData, setCoins] = useState([]);

    useEffect(() => {
        setCoins(coins);
    }, [coins])

    const balanceKey = Object.keys(balance).filter(list => list.includes('balance'))
    const symbols = ['btc', 'eth', 'xht', 'usdt']
    const selectedCoins = coinsData.filter(coin => balanceKey.includes(`${coin.symbol}_balance`) && symbols.includes(coin.symbol));
    if (exchange && exchange.coins && exchange.coins.length) {
        exchange.coins.forEach((coin) => {
            if (balanceKey.includes(`${coin.symbol}_balance`)
                && !symbols.includes(coin.symbol)) {
                selectedCoins.push(coin);
            }
        });
    }

    let balanceData = {};
    balanceKey.forEach(val => {
        balanceData = {
            ...balanceData,
            [val]: balance[val]
        }
    })

    const onClickFilter = (value) => {
        if (value.length) {
            const lowercasedValue = value.toLowerCase();
            let result = coins.filter(list => {
                return list.symbol.toLowerCase().includes(lowercasedValue) ||
                    list.fullname.toLowerCase().includes(lowercasedValue)
            });
            setCoins(result);
        } else {
            setCoins(coins);
        }
    }

    return (
        <Cotainer>
            <DescriptionWrapper>
                <div className={constant.isExchangeExpired ? "expired-status" : ""}>
                    <div className="title-description">
                        <h2>
                            <b>Wallet</b>
                        </h2>
                        <div className="filter-wrapper">
                            <DataFilter
                                handleSearch={onClickFilter}
                            />
                        </div>
                    </div>
                    <div className="table-wrap table-wrapper">
                        <Table
                            columns={
                                TABLE_WALLET_COLUMN(
                                    crypto_wallet,
                                    balanceData,
                                    // getCryptoAddress,
                                    openDeposit,
                                    openWithdraw
                                )
                            }
                            dataSource={selectedCoins}
                            rowKey={(data) => {
                                return data.id;
                            }}
                            pagination={false}
                        />
                    </div>
                </div>
                {constant.isExchangeExpired && <ExchangeTerminateMessage />}
            </DescriptionWrapper>
        </Cotainer>
    );
}

export default WalletBalance;
